module.exports = __webpack_public_path__ + "img/404.18c74068.png";